(function () {
  var root = document.querySelector('[data-science-library-toc]');
  if (!root) return;

  var content = root.querySelector('[data-toc-content]');
  var list = root.querySelector('[data-toc-list]');
  if (!content || !list) return;

  var headings = content.querySelectorAll('h2');
  if (!headings.length) {
    // No headings to build a TOC from — hide the sidebar rather than
    // show an empty box.
    var sidebar = root.querySelector('.science-library-article-body__sidebar');
    if (sidebar) sidebar.hidden = true;
    return;
  }

  var usedIds = {};
  function slugify(text) {
    var base = text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    var id = base || 'section';
    var suffix = 1;
    while (usedIds[id]) {
      suffix += 1;
      id = base + '-' + suffix;
    }
    usedIds[id] = true;
    return id;
  }

  var links = [];

  headings.forEach(function (heading) {
    if (!heading.id) heading.id = slugify(heading.textContent || '');
    var link = document.createElement('a');
    link.href = '#' + heading.id;
    link.textContent = heading.textContent;
    list.appendChild(link);
    links.push({ link: link, target: heading });
  });

  if (root.getAttribute('data-toc-show-references') === 'true') {
    var refSection = document.getElementById('science-library-references');
    if (refSection) {
      var refLink = document.createElement('a');
      refLink.href = '#science-library-references';
      refLink.textContent = 'References';
      list.appendChild(refLink);
      links.push({ link: refLink, target: refSection });
    }
  }

  var frameworkSection = document.getElementById('science-library-evidence-framework');
  if (frameworkSection) {
    var frameworkLink = document.createElement('a');
    frameworkLink.href = '#science-library-evidence-framework';
    frameworkLink.textContent = 'Evidence Framework';
    list.appendChild(frameworkLink);
    links.push({ link: frameworkLink, target: frameworkSection });
  }

  if (!('IntersectionObserver' in window) || links.length === 0) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var match = links.filter(function (item) {
          return item.target === entry.target;
        })[0];
        if (!match) return;
        links.forEach(function (item) {
          item.link.classList.toggle('is-active', item === match);
        });
      });
    },
    { rootMargin: '-20% 0px -70% 0px' }
  );

  links.forEach(function (item) {
    observer.observe(item.target);
  });
})();
